import AlsoCheckoutForm from 'Components/Also/CheckoutForm/CheckoutForm'
import AluxoCheckoutForm from 'Components/Aluxo/Checkout/CheckoutForm/CheckoutForm'
import config from 'Lib/config'

const CheckoutForm = config.reseller.also ? AlsoCheckoutForm : AluxoCheckoutForm

export default CheckoutForm
